'use client';

import React, { useState } from 'react';



interface Region {
  id: number;
  name: string;
  countries: number;
  partners: number;
  icon: string;
  color: string;
}

const regions: Region[] = [
{
  id: 1,
  name: 'Europe',
  countries: 18,
  partners: 120,
  icon: 'GlobeEuropeAfricaIcon',
  color: 'bg-primary'
},
{
  id: 2,
  name: 'Asia Pacific',
  countries: 15,
  partners: 150,
  icon: 'GlobeAsiaAustraliaIcon',
  color: 'bg-secondary'
},
{
  id: 3,
  name: 'Americas',
  countries: 12,
  partners: 90,
  icon: 'GlobeAmericasIcon',
  color: 'bg-accent'
},
{
  id: 4,
  name: 'Africa',
  countries: 10,
  partners: 80,
  icon: 'GlobeEuropeAfricaIcon',
  color: 'bg-success'
},
{
  id: 5,
  name: 'Middle East',
  countries: 8,
  partners: 60,
  icon: 'GlobeAsiaAustraliaIcon',
  color: 'bg-warning'
}];


export default function GlobalPresenceMap() {
  const [selectedRegion, setSelectedRegion] = useState<number | null>(null);

  return;













































































































}